import { Action, NoticeType } from '@core/databus/IMessage'
import { MicroAppId } from '@core/application/ApplicationConstants'
import type { SysNotice } from '@/core/Notification/NotificationManager'
import { generateDebounceNoticeSender } from '@/core/Notification/NotificationManager'
import { useSharedActiveMainHeaderItem, MainHeaderItems } from '@/core/compositions/ActiveMainHeaderItem'
import { URLBuilder, isDesktop, isInIosAPP } from '@core/Utils'
import { PATH_DOWNLOAD_CERTIFICATE_SERVICE, INSTANCE as cloudAdapter } from '@/netadapters/CloudAdapter'
import { getSmfServerApiBaseUrl } from '@/BuildConfig'
import { debounce } from 'lodash-es'
import { TimeConstants } from '../Constants'
import { IOSEventName, NativeBridge } from '@nativeAPP/IOSUtils'

export const LAN_AVAILABILITY_IS_PROMPTED = 'LAN_AVAILABILITY_IS_PROMPTED'

export interface CallbackListener {
  executeTask(createTaskByOcs?: boolean): void
}

export enum TransmissionType {
  FILE_UPLOAD,
  FILE_DOWNLOAD,
  FILE_OPEN,
}
const { currentSelectedItem, onCurrentSelectedItemUpdated } = useSharedActiveMainHeaderItem()

class CertificateManager {
  transmissionType: TransmissionType = TransmissionType.FILE_UPLOAD
  #LANAvailabilityNotice = generateDebounceNoticeSender(
    {
      appId: MicroAppId.FILE_MANAGER,
      msg: 'owork_base.notice_message.notice_lan_prompt',
      action: Action.LAN_PROMPT,
      type: NoticeType.COMMON_ACTION,
    },
    LAN_AVAILABILITY_IS_PROMPTED
  )

  async showLANAvailabilityNotice(sysNoticeOverride?: Partial<SysNotice>) {
    if (isInIosAPP()) {
      this.#emitIOSAPPInstallCertificate()

      return
    }
    if (!(await isDesktop())) return

    // 传输弹窗已存在
    if (currentSelectedItem.value === MainHeaderItems.TRANSMISSION_LIST) {
      const showLANAvailabilityNotice = (selectedItem?: MainHeaderItems) => {
        // 因为传输任务是异步启动的，所以存在传输弹窗正准备弹出的情况
        if (selectedItem === MainHeaderItems.TRANSMISSION_LIST) return
        this.#LANAvailabilityNotice(sysNoticeOverride)
        onCurrentSelectedItemUpdated.value.delete(showLANAvailabilityNotice)
      }

      onCurrentSelectedItemUpdated.value.add(showLANAvailabilityNotice)
    } else {
      this.#LANAvailabilityNotice(sysNoticeOverride)
    }
  }

  #emitIOSAPPInstallCertificate = debounce(async () => {
    const isPrompted = window.localStorage.getItem(LAN_AVAILABILITY_IS_PROMPTED) ?? 'false'

    if (isPrompted === 'true') return
    const certToken = await cloudAdapter.getCertificateToken()

    if (certToken) {
      const certificateUrl = new URLBuilder(getSmfServerApiBaseUrl())
        .appendPath(PATH_DOWNLOAD_CERTIFICATE_SERVICE)
        .appendQuery({ certToken })
        .toString()

      NativeBridge.getInstance().callNativeMethod(IOSEventName.INSTALL_CERTIFICATE, { certificateUrl })
      window.localStorage.setItem(LAN_AVAILABILITY_IS_PROMPTED, 'true')
    }
  }, TimeConstants.DEFAULT_DEBOUNCING_IN_MS)
}

const INSTANCE = new CertificateManager()

export { INSTANCE }
